import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Card, Dropdown, Form, Icon, Message, Segment } from "semantic-ui-react"
import { useGroupStore, useMetaACLStore, MetaACLType, GroupType, useACLStore, useUserStore, usePermissionStore, ACLType } from "../store"

const PageUserGroupOrPermission = () => {
  type dropDownEntry = {
    key: number | undefined,
    value: number | undefined,
    text: string | undefined,
  }
  const groupStore = useGroupStore()
  const permissionStore = usePermissionStore()
  const userStore = useUserStore()
  const aclStore = useACLStore()
  const metaACLStore = useMetaACLStore()
  const { userId } = useParams<{ userId: string | undefined }>()
  const { groupId } = useParams<{ groupId: string | undefined }>()
  const { permissionId } = useParams<{ permissionId: string | undefined }>()
  const [selectedGroup, setSelectedGroup] = useState<number>()
  const [selectedPermission, setSelectedPermission] = useState<number>()
  const [filtros, setFiltros] = useState<{[chave: string]:string}>()
  const [acls, setACLs] = useState<ACLType[]>()
  const [groupEntries, setGroupEntries] = useState<dropDownEntry[]>()
  const [permissionEntries, setPermissionEntries] = useState<dropDownEntry[]>()
  const [metaACLs, setMetaACLs] = useState<MetaACLType[]>()

  useEffect(() => {
    groupStore.list().then(
      ({results}) => setGroupEntries(results.map(g => fromGroupOrPermissionToEntry(g)))
    )
    permissionStore.list().then(
      ({results}) => setPermissionEntries(results.map(p => fromGroupOrPermissionToEntry(p)))
    )
    metaACLStore.list().then(
      ({results}) => setMetaACLs(results))
  }, [])

  useEffect(() => {
    if (!groupId) {
      return
    }
    setSelectedGroup(parseInt(groupId || "0"))
  }, [groupId])

  useEffect(() => {
    if (!permissionId) {
      return
    }
    setSelectedPermission(parseInt(permissionId || "0"))
  }, [permissionId])

  useEffect(() => {
    refresh()
  }, [selectedGroup, selectedPermission, metaACLs])

  const handleChangeGroupDropdown = (e: any, data: any) => {
    setSelectedGroup(data.value)
  }

  const handleChangePermissionDropdown = (e: any, data: any) => {
    setSelectedPermission(data.value)
  }

  const handleChangeInput = (acl: ACLType, chave: string, valor: string) => {
    const ff = Object.assign({}, filtros, {[chave]: valor})
    setFiltros(ff)
    const f = acl.filtros.find(f => f.chave === chave)
    if (f) f.valor = valor
    setACLs(acls)
  }

  const fromGroupOrPermissionToEntry = (g: GroupType) => (
    {key: g?.id, value: g?.id, text: g?.name}
  )

  const entriesForDomain = (domain: {[id: number]: string} | undefined) => (
    Object.entries(domain || {}).map(
      ([id, label]) => ({key: id, value: id, text: label})
    )
  )

  const metaACL = () => metaACLs?.find(
    ma => (
      (ma.group === selectedGroup && !ma.permission) ||
      (ma.permission === selectedPermission && !ma.group)
    )
  )

  const removeACL = (acl: ACLType) => {
    setACLs(acls?.filter(acl_ => acl_ !== acl))
  }

  const refresh = () => {
    if (!selectedGroup && !selectedPermission) {
      setACLs([])
      return
    }
    aclStore.list({
      user: parseInt(userId || "0"),
      group: selectedGroup,
      permission: selectedPermission,
    }).then(({results}) => {
      const ma = metaACL()
      if (ma) {
        const newACL: ACLType = {
          id: 0,
          user: parseInt(userId || "0"),
          group: selectedGroup || 0,
          permission: selectedPermission || 0,
          filtros: ma.filtros.map(f => ({chave: f.chave, valor: ''})),
          metaACL: ma,
        }
        setACLs(results.concat(newACL))
      }
    })
  }

  return (
    <Card fluid className="card-form">
      <Card.Content>
        <Form
            className="formPautas"
            error={Boolean(userStore.checkError("detail"))}
            success={Boolean(userStore.checkSucess())}
        >
          <Message
            icon="times circle outline"
            error
            header={userStore.checkError("detail")}
          />
          <Message icon="check circle outline" success
            header={userStore.checkSucess()} />
          {groupId && <Form.Field>
            <label>Grupo:</label>
            <Dropdown
              placeholder="Selecione um grupo"
              fluid
              search
              selection
              options={groupEntries}
              onChange={(e, data) => handleChangeGroupDropdown(e, data)}
              value={selectedGroup}
              disabled={(groupId || 0) > 0}
            />
          </Form.Field>}
          {permissionId && <Form.Field>
            <label>Permissão:</label>
            <Dropdown
              placeholder="Selecione uma permissão"
              fluid
              search
              selection
              options={permissionEntries}
              onChange={(e, data) => handleChangePermissionDropdown(e, data)}
              value={selectedPermission}
              disabled={(permissionId || 0) > 0}
            />
          </Form.Field>}
          {(() => {
          const ma = metaACL()
          return acls?.map(
            acl => <>
            <h5>{acl.id ? "ACL #"+acl.id: "Nova ACL"} <Icon name="trash alternate" onClick={() => removeACL(acl)} /></h5>
            {ma?.filtros.map(
              f => metaACLStore.dominioACLFilter([ma], undefined, f.chave) ?
              <Form.Field>
              <label>{metaACLStore.labelACLFilter([ma], undefined, f.chave)}</label>
              <Dropdown
                placeholder={`Selecione um ${metaACLStore.labelACLFilter([ma], undefined, f.chave)}`}
                fluid
                search
                selection
                options={entriesForDomain(metaACLStore.dominioACLFilter([ma], undefined, f.chave))}
                onChange={(e, data) => handleChangeInput(
                  acl, f.chave, ''+data.value,
                )}
                value={acl.filtros.find(filtro => filtro.chave === f.chave)?.valor}
              />
              </Form.Field>
              :
              <Form.Input
                label={
                  metaACLStore.labelACLFilter([ma], undefined, f.chave)
                }
                type="text"
                value={acl.filtros.find(filtro => filtro.chave === f.chave)?.valor}
                onChange={(e, data) => { handleChangeInput(
                  acl, f.chave, data.value,
                ) }}
              />
            )}</>
          )})()}
        </Form>
        <Segment basic clearing className={"actions-button"}>
          <Button onClick={() => window.history.back()}>Cancelar/Fechar</Button>
          <Button
            name="user-group-salvar"
            onClick={() => (
              (groupId && userStore.saveGroup(
                parseInt(userId || '0'),
                selectedGroup || 0,
                {},
                acls || [],
              ).then(() => {
                refresh()
              })) ||
              (permissionId && userStore.savePermission(
                parseInt(userId || '0'),
                selectedPermission || 0,
                {},
                acls || [],
              ).then(() => {
                refresh()
              }))
            )}
            floated="right"
            disabled={userStore.checkLoading("save")}
          >
            Salvar
          </Button>
          <Button
            name="user-group-excluir"
            onClick={() => (
              (
                groupId && userStore.deleteGroup(
                  parseInt(userId || '0'),
                  selectedGroup || 0,
                )
              ) || 
              (
                permissionId && userStore.deletePermission(
                  parseInt(userId || '0'),
                  selectedPermission || 0,
                )
              )
            )}
            floated="right"
            disabled={userStore.checkLoading("delete")}
          >
            Excluir
          </Button>
        </Segment>
      </Card.Content>
    </Card>
  )
}

export default PageUserGroupOrPermission
